export default __webpack_public_path__ + "static/media/Speaker_List_Example_4.e95f5c0e.png";